namespace $.$$ {
	export class $shm_showcase_info extends $.$shm_showcase_info {
		entry() { return $shm_showcase_entries.find( entry => entry.id === this.entry_id() )! }
		fqn() { return $shm_showcase_fqn( this.entry() ) }
		@ $mol_mem
		description() {
			const entry = this.entry()
			const properties = $mol_fetch.text( `shm/showcase/docs/${ entry.id }.md` )
			const readme = entry.readme ? $mol_fetch.text( entry.readme ) : ''
			return [
				'`' + this.fqn() + '`',
				entry.description,
				'## Основные свойства',
				properties.trim(),
				...( readme ? [ '## README компонента', readme.replace( /^# .*(?:\r?\n|$)/, '' ).trim() ] : [] ),
			].join( '\n\n' )
		}
		readme_uri() {
			return this.repository_uri() + '/blob/' + this.branch() + '/'
				+ ( this.entry().readme.replace( /^(mol|shm)\//, '' ) || this.entry().path + '/readme.md' )
		}
		repository_uri() { return this.entry().package === 'mol' ? 'https://github.com/hyoo-ru/mam_mol' : 'https://github.com/hitalama/shm' }
		branch() { return this.entry().package === 'mol' ? 'master' : 'main' }
		source_uri() { return this.repository_uri() + '/tree/' + this.branch() + '/' + this.entry().path }
	}
}
